import type {
  AccountPrice as PointsBalance,
  FiatPrice,
} from "@b2bportal/hsbc-accounts-api";
import { accountRewardsApi } from "./api";

export const initialPointsBalance: PointsBalance = {
  value: NaN, // Used NaN instead of 0 so not displayed in the UI until value is fetched
  currency: "",
};
export const initialFiatPointsBalance: FiatPrice = {
  value: NaN,
  currencyCode: "",
  currencySymbol: "",
};

export const accountRewardsReducers = {
  [accountRewardsApi.reducerPath]: accountRewardsApi.reducer,
};

export const accountRewardsMiddleware = [accountRewardsApi.middleware];
